














import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({ name: 'Counter', components: {} })
export default class MyComponent extends Vue {
  @Prop({ default: '00' }) private number!: string

  @Prop({ default: '' }) private subtitle!: string

  @Prop({ default: 30 }) private size!: number

  get hasSubtitle() {
    return this.subtitle.length > 0
  }
}
